export const PREFIX = 'gl'

export const COLORS = [
    'orange',
    'red',
    'green',
    'yellow',
    'blue',
    'purple',
    'grey',
].sort((c1, c2) => c1.localeCompare(c2))
